/*
 * @Author: 朱亚
 * @Date: 2020-10-10 10:19:09
 * @说明：判断页面是否滚动到底部
 */
// 是否滚动到底部
const willScrollToBottom = (offsetBottom) => {
  let doc = document.documentElement || document.body
  let _scrollHeight = doc.scrollHeight
  let _pageHeight = window.innerHeight
  let _scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
  if (_scrollTop + _pageHeight + offsetBottom >= _scrollHeight) {
    return true
  }
  return false
}
// 定义插件
const install = Vue => {
  Object.defineProperties(Vue.prototype, {
    $willScrollToBottom: {
      get() {
        return willScrollToBottom
      }
    }
  })
}
export default { install }



// WEBPACK FOOTER //
// ./src/plugins/willScrollToBottom.js